module.exports = __webpack_public_path__ + "img/p66.e8e77161.png";